(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('strandSwap', function($route, urlUtils, destinationService, $location, pageStrand, currentDestination, $routeParams, resourceService) {
    function oppositeUrl(path, oppStrand, isEstab) {
        if (isEstab) {
            if ($routeParams.landingPageV2) {
                const matches = $routeParams.landingPageV2.match(/(\d+-\d+)-?(\d+)?/) || [];
                const strandParam = matches[2];

                //if the strand param is 1, remove it
                if (strandParam === '1') {
                    return `${matches[1]}/${$routeParams.urlText}`;
                }
                //if the strand param is absent or something other than 1, add 1 or replace it with 1
                return `${matches[1]}-1/${$routeParams.urlText}`;
            }
            return urlUtils.stripLeadingSlash(pageStrand.adjustUrl(path, oppStrand));
        }
        return path;
    }

    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'partials/home/directivetemplate?type=StrandSwap',
        scope: {
            hideIcon: '@',
            holidayMessage: '@',
            button: '='
        },
        link(scope) {
            currentDestination.getCurrentDestination().then(function(dest) {
                const isEstab = destinationService.destinationIsEstab(dest);
                scope.strand = dest.PageStrand;
                scope.holidayEnabled = dest.HolidayEnabled;

                scope.active = function(ps) {
                    return ps === scope.strand ? 'active' : '';
                };

                const oppStrand = pageStrand.opposite(scope.strand);
                if (isEstab) {
                    scope.altStrandUrl = oppositeUrl(dest.PagePath, oppStrand, isEstab);
                } else {
                    destinationService.getDetails(dest, undefined, { pageStrandOverride: oppStrand }).then(function(d) {
                        dest = _.assign({}, dest, d);
                        if (TRPCONFIG.IsMobileDevice && dest.PageStrand === 2) {
                            scope.altStrandUrl = 'holidays';
                        } else {
                            scope.altStrandUrl = urlUtils.stripLeadingSlash(urlUtils.appendExistingQueryString(d.PagePath));
                        }
                    });
                }

                scope.toggle = function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $location.url(scope.altStrandUrl);
                    if (isEstab) {
                        //this will not cause a reload because the route is set to prevent that so we need to force a reload
                        $route.reload();
                    }
                };

                scope.pageStrandEquals = ps => scope.strand ? scope.strand === ps : undefined;

                scope.message =
                    scope.pageStrandEquals(1) ? resourceService.get('LOOKINGFORFLIGHTSANDHOTEL') :
                    scope.pageStrandEquals(2) ? (scope.holidayMessage || resourceService.get('LOOKINGFORHOTEL')) :
                    null;
            });
        }
    };
});
})();
